import { useSpring, animated } from 'react-spring'

const Filters = (props) => {
  const cheveronActive = useSpring({
    transform: props.isActive ? "rotate(0deg)" : "rotate(180deg)"
   })

  return (
    <div onClick={props.onClick} className="flex flex-row gap-1 mr-2  align-items-center justify-content-center align-content-center cursor-pointer">
      <span>{props.children}</span> 
      <animated.div style={cheveronActive}> 
        <i className='pi pi-chevron-up'/> 
      </animated.div>
    </div>
  )
}

const Selected = ({children}) => {
  return (
    <div>{children}</div>
  )
}

const Options = ({children}) => {
  return (
    <ul className="flex text-blue-200 cursor-pointer pl-6">{children}</ul>
  )
}

const OptionItem = ({children}) => {
  return (
    <li className="mr-12 capitalize">{children}</li>
  )
}

Filters.Selected = Selected
Filters.Options = Options
Filters.OptionItem = OptionItem

export default Filters